import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Text, useTheme } from '@Sage/hoi-poi-ui';

const MetricBox = memo(({ label, value }) => {
    const theme = useTheme();

    return (
        <div className="fm-funnel-metrics__box">
            <Text
                type="body"
                light
                color={theme.colors.utility.textSecondary}
                className="fm-funnel-metrics__label"
            >
                {label.toUpperCase()}
            </Text>
            <Text
                type="h3"
                bold
                color={theme.colors.utility.textPrimary}
                className="fm-funnel-metrics__value"
            >
                {value?.toFixed ? value.toFixed(1) : value}%
            </Text>
        </div>
    );
});

MetricBox.displayName = 'MetricBox';

MetricBox.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
};

export default MetricBox;
